module.exports = __webpack_public_path__ + "img/6b2a7aadaca6a7ec7f501d651661a730.png";